/**
 * @return {{ise_click_rank: number}}
 */
export const search = (data) => ({
  ise_click_rank: data.position.toString(),
});
